/*
 * Application Insights JavaScript SDK - Debug Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
export var _DYN_IDENTIFIER = "identifier"; // Count: 4
export var _DYN_TRACKERS = "trackers"; // Count: 4
export var _DYN_DISABLE_NOTIFICATION0 = "disableNotifications"; // Count: 2
export var _DYN_NEW_LOG_ENTRY = "newLogEntry"; // Count: 7
export var _DYN_PUSH = "push"; // Count: 21
export var _DYN_GET_TRANSMISSION_CON1 = "getTransmissionControls"; // Count: 2
export var _DYN_EXCLUDE_KEYS = "excludeKeys"; // Count: 5
export var _DYN_MAX_MESSAGES = "maxMessages"; // Count: 4
export var _DYN_CREATE_ELEMENT = "createElement"; // Count: 35
export var _DYN_CLASS_NAME = "className"; // Count: 40
export var _DYN_INNER_HTML = "innerHTML"; // Count: 3
export var _DYN_APPEND_CHILD = "appendChild"; // Count: 32
export var _DYN_STOP_PROPAGATION = "stopPropagation"; // Count: 9
export var _DYN_IS_DISPLAYED = "isDisplayed"; // Count: 5
export var _DYN_NAME = "name"; // Count: 9
export var _DYN_LENGTH = "length"; // Count: 12
export var _DYN_SHOW_CHILDREN = "showChildren"; // Count: 8
export var _DYN_DUMP_TO_CONSOLE = "dumpToConsole"; // Count: 4
export var _DYN_LOG_PROCESS_TELEMETR2 = "logProcessTelemetry"; // Count: 2
export var _DYN_INCLUDE_FUNCTIONS = "includeFunctions"; // Count: 3
export var _DYN_POINTER_EVENTS = "pointerEvents"; // Count: 3
export var _DYN_PARENT_ELEMENT = "parentElement"; // Count: 9
export var _DYN_SET_TEXT_FILTER = "setTextFilter"; // Count: 4
export var _DYN_RENDER = "render"; // Count: 11
export var _DYN_GET_EL = "getEl"; // Count: 5
export var _DYN_REMOVE_CHILD = "removeChild"; // Count: 10
export var _DYN_SET_ATTRIBUTE = "setAttribute"; // Count: 7
export var _DYN_ONKEYUP = "onkeyup"; // Count: 4
export var _DYN_INNER_TEXT = "innerText"; // Count: 17
export var _DYN_ONCLICK = "onclick"; // Count: 9
export var _DYN_ONTOUCHEND = "ontouchend"; // Count: 5
export var _DYN_ONKEYDOWN = "onkeydown"; // Count: 3
export var _DYN_PREVENT_DEFAULT = "preventDefault"; // Count: 3
export var _DYN_TARGET = "target"; // Count: 4
export var _DYN_CHILDREN = "children"; // Count: 5
export var _DYN_FILTER_LIST = "filterList"; // Count: 5
export var _DYN_FOCUS = "focus"; // Count: 7
export var _DYN_REPLACE = "replace"; // Count: 6
export var _DYN_SUBSTRING = "substring"; // Count: 5
export var _DYN_TO_STRING = "toString"; // Count: 4
export var _DYN_IS_ERROR = "isError"; // Count: 4
//# sourceMappingURL=__DynamicConstants.js.map